export enum UserAnswer {
  YES = "YES",
  NO = "NO",
  NOT_ANSWERED = "NOT_ANSWERED",
}
